import React from "react";

export default () => (
  <svg
    height="1em"
    width="1em"
    viewBox="0 0 18 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M8.75,11.25 C8.05964406,11.25 7.5,11.8096441 7.5,12.5 L7.5,22.5 C7.5,23.1903559 8.05964406,23.75 8.75,23.75 L21.25,23.75 C21.9403559,23.75 22.5,23.1903559 22.5,22.5 L22.5,12.5 C22.5,11.8096441 21.9403559,11.25 21.25,11.25 L8.75,11.25 Z M8.75,8.75 L21.25,8.75 C23.3210678,8.75 25,10.4289322 25,12.5 L25,22.5 C25,24.5710678 23.3210678,26.25 21.25,26.25 L8.75,26.25 C6.67893219,26.25 5,24.5710678 5,22.5 L5,12.5 C5,10.4289322 6.67893219,8.75 8.75,8.75 Z M15,13.75 C16.3807119,13.75 17.5,14.8692881 17.5,16.25 C17.5,17.175077 16.9975516,17.9828008 16.2506685,18.4151576 L16.25,20.625 C16.25,21.3153559 15.6903559,21.875 15,21.875 C14.3096441,21.875 13.75,21.3153559 13.75,20.625 L13.75,20.625 L13.750345,18.4157441 C13.002903,17.9835314 12.5,17.1754954 12.5,16.25 C12.5,14.8692881 13.6192881,13.75 15,13.75 Z M15,3.75 C17.7614237,3.75 20,5.98857625 20,8.75 C20,9.44035594 19.4403559,10 18.75,10 C18.0596441,10 17.5,9.44035594 17.5,8.75 C17.5,7.36928813 16.3807119,6.25 15,6.25 C13.6192881,6.25 12.5,7.36928813 12.5,8.75 C12.5,9.44035594 11.9403559,10 11.25,10 C10.5596441,10 10,9.44035594 10,8.75 C10,5.98857625 12.2385763,3.75 15,3.75 Z"
        id="path-1"
      ></path>
    </defs>
    <g fill="none" fillRule="nonzero">
      <g transform="translate(-20.000000, -789.000000)">
        <g transform="translate(15.000000, 626.000000)">
          <g transform="translate(0.000000, 160.000000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1"></use>
            </mask>
            <use fill="#737373" fillRule="nonzero" xlinkHref="#path-1"></use>
            <g mask="url(#mask-2)">
              <rect x="0" y="0" width="30" height="30"></rect>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
